import { iconMap } from '../maps/iconMap';
import { colors } from '../maps/colors';
import Button from '@mui/material/Button';

export default function Btn(props) {

    const { customtheme } = props;

    const StartIcon = props.startIcon ? iconMap[props.startIcon] : <></>;
    const EndIcon = props.endIcon ? iconMap[props.endIcon] : <></>;

    let style = props.style || {};

    switch (customtheme) {
        case 'normal':
            break;
        case 'white':
            if (props.variant === 'outlined') {
                style = { ...style, color: colors.WHITE60, background: colors.WHITE20, border: `1px solid ${colors.WHITE40}`  };
            } else {
                style = { ...style, color: colors.WHITE, background: colors.WHITE80, border: `1px solid ${colors.WHITE40}`, boxShadow: 'none'  };
            }
             break;
        case 'cyan':
            if (props.variant === 'outlined') {
                style = { ...style, color: colors.WHITE, border: `1px solid ${colors.CYAN}` };
            } else {
                style = { ...style, color: colors.WHITE, background: colors.CYAN };
            }
            break;
        case 'teal':
            if (props.variant === 'outlined') {
                style = { ...style, color: colors.WHITE, border: `1px solid ${colors.TEAL}` };
            } else if(props.variant === 'contained') {
                style = { ...style, color: colors.WHITE, background: colors.TEAL };
            }else {
                style = { ...style, color: colors.WHITE };
            }
            break;
        default:
            if (props.variant === 'outlined') {
                style = { ...style, color: colors.LIGHT_ORANGE, border: `1px solid ${colors.WHITE40}` };
            } else {
                style = { ...style, color: colors.LIGHT_ORANGE, background: colors.GREEN };
            }
    }

    return (
        <Button {...props} style={style} variant={props.variant || 'contained'} startIcon={props.startIcon && <StartIcon />} endIcon={props.endIcon && <EndIcon />}>
            {props.children}
        </Button>
    )
}
